import { firebaseRef, TRIAL_DAYS, disposableEmails } from 'config'
import { routeActions } from 'react-router-redux'
import { initialUserbetsLoaded } from 'actions/userbets'
import { bookmakerListsChanged } from 'actions/bookmakerLists'
import { calculateTotalProfit } from 'utils/calculations'
import { identify } from 'utils/segment'
import moment from 'moment'
import Firebase from 'firebase'

export const SIGNUP_ERROR = 'SIGNUP_ERROR'
export const SIGNUP_REQUEST = 'SIGNUP_REQUEST'
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS'
export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_ERROR = 'LOGIN_ERROR'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGGED_OUT = 'LOGGED_OUT'
export const USER_UPDATED = 'USER_UPDATED'
export const HIJACK_USER = 'HIJACK_USER'

export function hijackUser(id) {
  return (dispatch, getState) => {
    firebaseRef.child('users').child(id).once('value', snapshot => {
      let userObject = snapshot.val()
      dispatch(userUpdated(Object.assign({}, userObject, {
        id: snapshot.key(),
        hijacked: true
      })))
    })
    firebaseRef.child('userbets').orderByChild('user').equalTo(id).once('value', snap => {
      let userbets = []
      snap.forEach(s => {
        userbets.push(Object.assign({}, s.val(), { id: s.key() }))
      })
      const settledBets = userbets.filter(b => b.status !== 1)
      identify(id, {
        totalProfit: calculateTotalProfit(settledBets, getState().currencies, 'USD'),
        bets: userbets.length
      })
      dispatch(initialUserbetsLoaded(userbets))
    })

    firebaseRef.child('bookmakerLists').child(id).once('value', snap => {
      let bookmakerLists = {}
      if (snap.exists())
        bookmakerLists = snap.val()
      dispatch(bookmakerListsChanged(bookmakerLists))
    })
  }
}

export function releaseHijack() {
  return () => {
    document.location = '/dashboard'
  }
}

function loginError(error) {
  return {
    type: LOGIN_ERROR,
    error
  }
}

export function loginRequest() {
  return {
    type: LOGIN_REQUEST
  }
}

export function loginSuccess() {
  window.analytics.identify()
  return dispatch => {
    dispatch({
      type: LOGIN_SUCCESS
    })
    dispatch(routeActions.push('/dashboard'))
  }
}

export function userUpdated(user) {
  identify(user.id, user)
  return {
    type: USER_UPDATED,
    user
  }
}

export function changeUser(id, changes) {
  return () => {
    firebaseRef.child('users').child(id).update(changes)
  }
}

function signupError(error) {
  return {
    type: SIGNUP_ERROR,
    error
  }
}

function signupRequest() {
  return {
    type: SIGNUP_REQUEST
  }
}

function signupSuccess() {
  return dispatch => {
    dispatch({
      type: SIGNUP_SUCCESS
    })
    dispatch(routeActions.push('/get-started'))
  }
}
export function signup(data) {
  const { email } = data
  if (email.match(disposableEmails)) {
    return signupError('you have to sign up with a real email.')
  }
  return dispatch => {
    dispatch(signupRequest())
    const { password } = data
    const { coupon } = data
    firebaseRef.createUser({email, password}, (error) => {
      if (!!error) {
        dispatch(signupError(error.message))
      } else {
        firebaseRef.authWithPassword(data, (error, data) => {
          if (!!error) {
            dispatch(signupError(error.message))
          } else {
            let userObject = {
              email,
              createdAt: Firebase.ServerValue.TIMESTAMP,
              startingBankroll: 0,
              forumName: 'Anonymous better',
              verified: false,
              permissionLevel: 0,
              currency: 'USD',
              trialEndsAt: +moment().add(TRIAL_DAYS, 'days'),
              kellyFrac: 0.3,
              coupon
            }
            window.analytics.alias(data.uid)
            identify(data.uid, userObject)
            window.analytics.track('Signed up')
            firebaseRef.child('users').child(data.uid).set(userObject)
            let ref = firebaseRef.child('bookmakerLists').child(data.uid).push()
            ref.set({
              name: 'My first list',
              bookmakers: {
                539: true, // Marathonbet
                126: true, // Bet365
                332: true, // Betsafe
              }
            })
            dispatch(signupSuccess())
          }
        })
      }
    })
  }
}

export function loginWithFacebook() {
  return dispatch => {
    dispatch(loginRequest())
    firebaseRef.authWithOAuthRedirect('facebook', (err) => {
      if (!!err)
        return dispatch(loginError(err.message))
    }, {
      scope: 'email'
    })
  }
}

export function signupWithFacebook(coupon) {
  return dispatch => {
    dispatch(signupRequest())
    firebaseRef.authWithOAuthPopup('facebook', (err, data) => {
      if (!!err) {
        return dispatch(signupError(err.message))
      }
      const { email, displayName } = data.facebook
      console.log(email)
      firebaseRef.child('users').child(data.uid).once('value', snap => {
        if (snap.exists()) {
          return dispatch(loginSuccess())
        }
        window.analytics.alias(data.uid)
        let userObject = {
          email: email || 'no@email.com',
          displayName,
          coupon,
          currency: 'USD',
          createdAt: Firebase.ServerValue.TIMESTAMP,
          startingBankroll: 0,
          forumName: 'Anonymous better',
          verified: true,
          provider: 'facebook',
          permissionLevel: 0,
          trialEndsAt: +moment().add(TRIAL_DAYS, 'days'),
          kellyFrac: 0.3
        }
        identify(data.uid, userObject)
        window.analytics.track('Signed up')
        firebaseRef.child('users').child(data.uid).set(userObject)
        let ref = firebaseRef.child('bookmakerLists').child(data.uid).push()
        ref.set({
          name: 'My first list',
          bookmakers: {
            539: true, // Marathonbet
            126: true, // Bet365
            332: true, // Betsafe
          }
        })
        dispatch(signupSuccess())
      })
    }, {
      scope: 'email,public_profile'
    })
  }
}

export function login(data) {
  return dispatch => {
    dispatch(loginRequest())
    firebaseRef.authWithPassword(data, (error) => {
      if (error) {
        dispatch(loginError(error.message))
      } else {
        dispatch(loginSuccess())
      }
    })
  }
}

export function loggedOut() {
  window.analytics.reset()
  return {
    type: LOGGED_OUT
  }
}

export function logout() {
  return dispatch => {
    firebaseRef.unauth()
    dispatch(loggedOut())
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/auth.js
 **/